import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import { getStoriesByAgeGroup } from "~/stories";
import { AGE_GROUPS, type StoryCategory } from "~/types/story";
import StoryCard from "~/components/StoryCard";
import CategoryNav from "~/components/CategoryNav";

export default function AgeGroupPage() {
  const { ageGroup } = useParams<{ ageGroup: string }>();
  const [selectedCategory, setSelectedCategory] = useState<StoryCategory | undefined>();

  const groupInfo = AGE_GROUPS.find((g) => g.id === ageGroup);
  const allStories = getStoriesByAgeGroup(ageGroup || "");
  const filteredStories = selectedCategory
    ? allStories.filter((s) => s.category === selectedCategory)
    : allStories;

  if (!groupInfo) {
    return (
      <div className="max-w-4xl mx-auto p-8 text-center">
        <h1 className="text-2xl mb-4">Age group not found</h1>
        <Link to="/" className="text-blue-600 hover:underline">&larr; Back to home</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className={`bg-gradient-to-r ${groupInfo.color} text-white py-12 px-6`}>
        <div className="max-w-6xl mx-auto">
          <Link to="/" className="text-white/80 hover:text-white text-sm mb-4 inline-block">
            &larr; Back to home
          </Link>
          <h1 className="text-4xl font-bold mb-2">{groupInfo.label}</h1>
          <p className="text-lg opacity-90">{groupInfo.description}</p>
          <p className="text-sm opacity-75 mt-2">Ages {groupInfo.id} &middot; {allStories.length} stories</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-6 py-8">
        <CategoryNav selected={selectedCategory} onSelect={setSelectedCategory} />

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredStories.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>

        {filteredStories.length === 0 && (
          <div className="text-center py-16 text-gray-400">
            <p className="text-lg">No stories in this category yet.</p>
            <p className="text-sm mt-2">Check back soon!</p>
          </div>
        )}
      </div>
    </div>
  );
}
